export const products = [
  {
    id: 1,
    name: "Amla Detox",
    category: "Supplements & Detox",
    price: 13600,
    originalPrice: 16500,
    rating: 4.8,
    reviews: 1245,
    image: "/product_amladetox.jpg",
    badge: "Best Seller",
    description: "Premium detox supplement enriched with Indian Amla fruit extract. Boost immunity and vitality.",
    features: ["Natural Ingredients", "Detox Formula", "High Potency", "30 Servings"],
    colors: ["#8B7355", "#E8D4B8", "#2D5016"],
    stock: 52,
  },
  {
    id: 2,
    name: "CoMem",
    category: "Supplements & Detox",
    price: 5000,
    originalPrice: 7000,
    rating: 4.7,
    reviews: 892,
    image: "/product_comem.jpg",
    badge: "New",
    description: "Advanced memory and cognitive support formula with natural botanicals.",
    features: ["Brain Support", "Focus Enhanced", "Natural Extracts", "Clinically Tested"],
    colors: ["#3D3D3D", "#F5E6D3", "#1A1A1A"],
    stock: 38,
  },
  {
    id: 3,
    name: "Decumar",
    category: "Skincare & Treatments",
    price: 14000,
    originalPrice: 19500,
    rating: 4.9,
    reviews: 1567,
    image: "/product_decumar.jpg",
    badge: "Hot",
    description: "Specialized skin whitening and complexion treatment. Visible results in 2 weeks.",
    features: ["Skin Brightening", "Fast Acting", "Dermatologist Approved", "Safe Formula"],
    colors: ["#F5F5DC", "#E6B8B8", "#8B7D6B"],
    stock: 45,
  },
  {
    id: 4,
    name: "Miri",
    category: "Skincare & Treatments",
    price: 11900,
    originalPrice: 16500,
    rating: 4.6,
    reviews: 734,
    image: "/product_miri.jpg",
    badge: "Premium",
    description: "Luxurious beauty cream with pearl and gold essence. Youthful glow guaranteed.",
    features: ["Pearl Extract", "Gold Infused", "Anti-Aging", "Hydrating"],
    colors: ["#F4E4C1", "#D4AF37", "#8B6F47"],
    stock: 29,
  },
  {
    id: 5,
    name: "Nau Nau",
    category: "Herbal & Natural",
    price: 8900,
    originalPrice: 12400,
    rating: 4.5,
    reviews: 612,
    image: "/product_naunau.jpg",
    badge: "Sale",
    description: "Traditional herbal formula for wellness and natural vitality.",
    features: ["Herbal Blend", "Traditional Recipe", "Pure Ingredients", "No Additives"],
    colors: ["#8B6914", "#D3A574", "#654321"],
    stock: 64,
  },
  {
    id: 6,
    name: "NMF Barrier Repair",
    category: "Skincare & Treatments",
    price: 8600,
    originalPrice: 12000,
    rating: 4.8,
    reviews: 1089,
    image: "/product_nmf.jpg",
    badge: "Best Seller",
    description: "Professional skin barrier repair cream with natural moisturizing factor.",
    features: ["NMF Complex", "Barrier Repair", "Hypoallergenic", "Long Lasting"],
    colors: ["#F0F0F0", "#E8D5C4", "#A0A0A0"],
    stock: 56,
  },
  {
    id: 7,
    name: "Serum Trioderma",
    category: "Serums & Advanced",
    price: 7500,
    originalPrice: 10500,
    rating: 4.9,
    reviews: 1423,
    image: "/product_serum_trioderma.jpg",
    badge: "Limited",
    description: "Advanced triple-action serum for complete skin transformation and rejuvenation.",
    features: ["Triple Action", "Lifting Effect", "Brightening", "Anti-Wrinkle"],
    colors: ["#2C1810", "#D4A574", "#8B4513"],
    stock: 18,
  },
  {
    id: 8,
    name: "Thorano",
    category: "Supplements & Detox",
    price: 6000,
    originalPrice: 7000,
    rating: 4.7,
    reviews: 856,
    image: "/product_thorano.jpg",
    badge: "Hot",
    description: "Specialized throat and respiratory support with natural ingredients.",
    features: ["Throat Care", "Respiratory Support", "Soothing Formula", "Natural"],
    colors: ["#8B0000", "#D2B48C", "#1a1a2e"],
    stock: 41,
  },
  {
    id: 9,
    name: "Tóc May Hair Care",
    category: "Hair Care",
    price: 13600,
    originalPrice: 18900,
    rating: 4.6,
    reviews: 945,
    image: "/product_tocmay.jpg",
    badge: "New",
    description: "Premium hair care treatment for silky smooth and shiny hair.",
    features: ["Hair Smoothing", "Shine Enhancer", "Repair Formula", "Heat Protection"],
    colors: ["#8B7355", "#D2B48C", "#654321"],
    stock: 73,
  },
  {
    id: 10,
    name: "Vegan Collagen",
    category: "Anti-Aging & Wellness",
    price: 20000,
    originalPrice: 27000,
    rating: 4.8,
    reviews: 1134,
    image: "/product_vegan.jpg",
    badge: "Premium",
    description: "Plant-based collagen booster for radiant and youthful skin.",
    features: ["Vegan Formula", "Collagen Boost", "Anti-Aging", "Cruelty-Free"],
    colors: ["#90EE90", "#F0FFF0", "#228B22"],
    stock: 51,
  },
];

export const categories = [
  { id: 1, name: "Supplements & Detox", icon: "🌿", color: "#7C3AED", count: 124 },
  { id: 2, name: "Skincare & Treatments", icon: "💆", color: "#F59E0B", count: 87 },
  { id: 3, name: "Hair Care", icon: "💇", color: "#10B981", count: 63 },
  { id: 4, name: "Serums & Advanced", icon: "🧴", color: "#EF4444", count: 45 },
  { id: 5, name: "Anti-Aging & Wellness", icon: "✨", color: "#EC4899", count: 92 },
  { id: 6, name: "Herbal & Natural", icon: "🌱", color: "#3B82F6", count: 78 },
];
